import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-scroll';
import FlatButton from 'material-ui/FlatButton';

const CardContentNAvigation = props => {
  const { set } = props;
  return (
    <div className='setCardNavigationContainer' style={{flex: '0 0 200px', padding: '10px'}}>
      <div className='setCardNavigationContent' style={{position: 'fixed'}}>
        {set.details &&
          <div>
            <Link activeClass="activePane" to="desc" spy={true} smooth={true} duration={500} >
              <FlatButton label='Описание' hoverColor='transparent' style={{width: '100%'}}></FlatButton>
            </Link>
          </div>
        }
        {set.complectation &&
          <div>
            <Link activeClass="activePane" to="compl" spy={true} smooth={true} duration={500} >
              <FlatButton label='Комплектация' hoverColor='transparent' style={{width: '100%'}}></FlatButton>
            </Link>
          </div>
        }
        <div>
          <Link activeClass="activePane" to="photo" spy={true} smooth={true} duration={500} >
            <FlatButton label='Фото' hoverColor='transparent' style={{width: '100%'}}></FlatButton>
          </Link>
        </div>
        {set.techData &&
          <div>
            <Link activeClass="activePane" to="tech" spy={true} smooth={true} duration={500} >
              <FlatButton label='Характеристики' hoverColor='transparent' style={{width: '100%'}}></FlatButton>
            </Link>
          </div>
        }
        {set.accessories &&
          <div>
            <Link activeClass="activePane" to="access" spy={true} smooth={true} duration={500} >
              <FlatButton label='Аксессуары' hoverColor='transparent' style={{width: '100%'}}></FlatButton>
            </Link>
          </div>
        }
      </div>
    </div>
  );
}

export default connect()(CardContentNAvigation);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/card/nav.js